/*eslint-disable */
import gasImage from '../../assets/sectors/natural_gas.jpg';
import electricityImage from '../../assets/sectors/electricity.jpg';
import weatherImage from '../../assets/sectors/weather.jpg';
import oilImage from '../../assets/sectors/oil.jpg';
import cryptoImage from '../../assets/sectors/crypto2.jpg';

export default {
    home: {
        title: 'Product Data Descriptions',
        data: [
            {
                category: 'North America Natural Gas',
                image: gasImage,
                dataSet: [
                    {
                        title: 'US/CAN interstates',
                        items: [
                            'Berkshire',
                            'Boardwalk',
                            'Dominion',
                            'Enbridge',
                            'KinderMorgan',
                            'Transcanada',
                            'Williams',
                            '170+ total',
                        ],
                    },
                ],
                dataSeries: [
                    'Operationally Available Nominations over 5 cycles',
                    'Unsubscribed Capacity',
                    'No Notice Activity',
                    'Gas Quality',
                    'Weather by Meter',
                    'Static Data',
                ],
            },
            {
                category: 'North America Electricity (Beta)',
                image: electricityImage,
                dataSet: [
                    {
                        title: 'US power',
                        items: [
                            'NYISO',
                            'ERCOT',
                            'CAISO',
                            'MISO',
                            'SPP',
                        ],
                    },
                    {
                        title: 'CAN Power Coming Soon',
                        items: ['IESO', 'AESO']
                    }
                ],
                dataSeries: ['LMP', 'Outages', 'DA', 'static data'],
            },
            {
                category: 'North America Weather',
                image: weatherImage,
                dataSet: [
                    {
                        title: 'US weather station data',
                        items: [
                            'Over 35,0000 Stations in the Lower 48'
                        ]
                    }
                ],
                dataSeries: [
                    'Temperature',
                    'Precipitation',
                    'Barometric Pressure',
                    'Wind Direction and Speed',
                    'Humidity',
                    'Cloud Layers'
                ]
            },
            {
                category: 'Cryptocurrencies (Beta)',
                image: cryptoImage,
                dataSet: [
                    {
                        title: 'Market Data, Trading Data',
                    },
                ],
                dataSeries: [
                    'Bitcoin',
                    'Ethereum',
                    'Tether',
                    'XRP',
                    'Bitcoin Cash',
                    'Bitcoin SV',
                ],
            },
            {
                category: 'Oil',
                image: oilImage,
                dataSet: [
                    {
                        title: 'US Oil by State (Beta)',
                        items: [
                            'TX',
                            'ND',
                            'AK',
                            'NM',
                            'CO',
                            'PA',
                            'CA',
                            'WY',
                            'OK',
                            'LA',
                            'UT',
                        ],
                    },
                ],
                dataSeries: ['Wells', 'Monthly Production'],
            },
        ],
    },
};
/*eslint-enable */
